// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file responses/v1/label_count_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/label_count_response.proto.
 */
export const file_responses_v1_label_count_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CidyZXNwb25zZXMvdjEvbGFiZWxfY291bnRfcmVzcG9uc2UucHJvdG8SDHJlc3BvbnNlcy52MSIpChJMYWJlbENvdW50UmVzcG9uc2USEwoLbGFiZWxfY291bnQYASABKARCggEKEGNvbS5yZXNwb25zZXMudjFCF0xhYmVsQ291bnRSZXNwb25zZVByb3RvUAFaBC4vcGKiAgNSWFiqAgxSZXNwb25zZXMuVjHKAgxSZXNwb25zZXNcVjHiAhhSZXNwb25zZXNcVjFcR1BCTWV0YWRhdGHqAg1SZXNwb25zZXM6OlYxYgZwcm90bzM'
    );

/**
 * @generated from message responses.v1.LabelCountResponse
 */
export type LabelCountResponse = Message<'responses.v1.LabelCountResponse'> & {
    /**
     * @generated from field: uint64 label_count = 1;
     */
    labelCount: bigint;
};

/**
 * Describes the message responses.v1.LabelCountResponse.
 * Use `create(LabelCountResponseSchema)` to create a new message.
 */
export const LabelCountResponseSchema: GenMessage<LabelCountResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_label_count_response, 0);
